import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsGetCollection_points_collectionPointIdContracts_contractIdDownload = z.any()
export type TagsGetCollection_points_collectionPointIdContracts_contractIdDownload = z.infer<typeof tagsGetCollection_points_collectionPointIdContracts_contractIdDownload>

export const paramsGetCollection_points_collectionPointIdContracts_contractIdDownload = z.object({ "collectionPointId": z.string().uuid(), "contractId": z.string().uuid() })
export type ParamsGetCollection_points_collectionPointIdContracts_contractIdDownload = z.infer<typeof paramsGetCollection_points_collectionPointIdContracts_contractIdDownload>

export const querystringGetCollection_points_collectionPointIdContracts_contractIdDownload = z.object({ "preview": z.boolean().optional() })
export type QuerystringGetCollection_points_collectionPointIdContracts_contractIdDownload = z.infer<typeof querystringGetCollection_points_collectionPointIdContracts_contractIdDownload>

export const responseGetCollection_points_collectionPointIdContracts_contractIdDownload = z.any()
export type ResponseGetCollection_points_collectionPointIdContracts_contractIdDownload = z.infer<typeof responseGetCollection_points_collectionPointIdContracts_contractIdDownload>

interface IGetCollection_points_collectionPointIdContracts_contractIdDownload extends BaseMethodType {
  tags: TagsGetCollection_points_collectionPointIdContracts_contractIdDownload,
  params: ParamsGetCollection_points_collectionPointIdContracts_contractIdDownload,
  querystring: QuerystringGetCollection_points_collectionPointIdContracts_contractIdDownload,
  response: ResponseGetCollection_points_collectionPointIdContracts_contractIdDownload
}
export const URL = '/collection-points/:collectionPointId/contracts/:contractId/download'
export const validation = {
  get: {
    tags: tagsGetCollection_points_collectionPointIdContracts_contractIdDownload,
    params: paramsGetCollection_points_collectionPointIdContracts_contractIdDownload,
    querystring: querystringGetCollection_points_collectionPointIdContracts_contractIdDownload,
    response: responseGetCollection_points_collectionPointIdContracts_contractIdDownload
  }
}
export interface Collection_points_collectionPointIdContracts_contractIdDownload extends BaseRouteType {
  get: IGetCollection_points_collectionPointIdContracts_contractIdDownload
}